import { Pipe, PipeTransform } from '@angular/core';
import { ProjectChecklistType } from '@portal-core/project-checklists/enums/project-checklist-type.enum';
import { ProjectChecklist } from '@portal-core/project-checklists/models/project-checklist.model';

/**
 * Returns the checklist tooltip.
 * Usage:
 *   checklist | mcProjectChecklistTooltip
 */
@Pipe({
  name: 'mcProjectChecklistTooltip'
})
export class ProjectChecklistTooltipPipe implements PipeTransform {
  transform(checklist: ProjectChecklist): string {
    if (!checklist) {
      return null;
    }

    const statusText = checklist.Analytics?.CompletedPercent === 100 ? 'Completed' : 'Incomplete';

    return checklist.Name +
      (checklist.Description ? '\n' + checklist.Description : '') +
      (checklist.Type === ProjectChecklistType.ProjectFiles ? '\nBranch: ' + checklist.BranchName : '') +
      (statusText ? '\n\n' + statusText : '');
  }
}
